(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('CrmOutboundReferralStatusDeleteController',CrmOutboundReferralStatusDeleteController);

    CrmOutboundReferralStatusDeleteController.$inject = ['$uibModalInstance', 'entity', 'CrmOutboundReferralStatus'];

    function CrmOutboundReferralStatusDeleteController($uibModalInstance, entity, CrmOutboundReferralStatus) {
        var vm = this;

        vm.crmOutboundReferralStatus = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            CrmOutboundReferralStatus.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
